<template>
  <button type="button"
          class="play-button padding-15"
          v-on:click="toggleAudio"
  >
          <span class="stop-button-header" v-if="playing">
            <img src="../assets/images/icons/pause-icon.svg">
          </span>
          <span v-if="!playing">
            <img src="../assets/images/icons/play-icon.svg">
          </span>
  </button>
</template>

<script>
import AudioElement from '@/mixins/AudioElement';

export default {
  name: 'PlayButtonHeader.vue',
  mixins: [new AudioElement()],
};
</script>

<style scoped>
  .play-button {
    display: inline-block;
    background: none;
    border: none;
    padding: 0;
    height: 73px;
    cursor: pointer;
  }

  span.paused {
    content: url('../assets/images/icons/pause-icon.svg');
  }
  span.playing {
    content: url('../assets/images/icons/play-icon.svg');
  }
</style>
